export var getIsAdmin = function (state) { return state.environment.isAdmin; };
//# sourceMappingURL=environment.js.map